import { useRef } from 'react';

import useGsapSection from '../../hooks/useGsapSection';

import { ScrambleReveal } from '../TextEffects';



const DEFAULT_META_ORDER = ['client', 'role', 'format', 'year', 'deliverables', 'process'];



const META_LABELS = {

  client: 'Client',

  role: 'Role',

  format: 'Format',

  engine: 'Engine',

  tools: 'Tools',

  year: 'Year',

  deliverables: 'Deliverables',

  process: 'Process',

  note: 'Note',

  live: 'Live',

};



const CaseStudyIntro = ({ meta, intro, variant = 'default', header, metaOrder, introNote }) => {

  const ref = useRef(null);

  const inView = useGsapSection(ref);



  const introParagraphs = Array.isArray(intro) ? intro : [intro];

  const order = metaOrder || DEFAULT_META_ORDER;



  const rows = order

    .filter((key) => meta[key])

    .map((key) => ({

      key,

      label: META_LABELS[key],

      value: meta[key],

    }));



  return (

    <section

      className={`cs-intro${variant === 'spacious' ? ' is-spacious' : ''}`}

      ref={ref}

      data-testid="case-study-intro"

    >

      {header && (

        <div className="cs-intro-header gsap-reveal">

          {header.stripLabel && header.index && (

            <span className="cs-intro-strip">

              <span className="cs-intro-strip-num">({header.index})</span>

              <span className="cs-intro-strip-divider" aria-hidden="true" />

              <ScrambleReveal text={header.stripLabel} externalInView={inView} delay={0.03} />

            </span>

          )}

          {header.studioLine && (

            <span className="cs-intro-studio">

              <ScrambleReveal text={header.studioLine} externalInView={inView} delay={0.08} />

            </span>

          )}

          {header.tagline && <p className="cs-intro-tagline">{header.tagline}</p>}

        </div>

      )}



      <div className="cs-intro-grid gsap-reveal">

        <dl className="cs-meta-list">

          {rows.map(({ key, label, value }) => (

            <div key={label} className="cs-meta-item">

              <dt>{label}</dt>

              <dd>

                {key === 'live' && value?.href ? (

                  <a

                    href={value.href}

                    className="cs-meta-live"

                    target="_blank"

                    rel="noopener noreferrer"

                  >

                    → {value.label} ↗

                  </a>

                ) : (

                  value

                )}

              </dd>

            </div>

          ))}

        </dl>

        <div className="cs-intro-body">

          {introParagraphs.map((paragraph, i) => (

            <p key={i} className="cs-intro-paragraph">

              {paragraph}

            </p>

          ))}

          {introNote && <p className="cs-intro-note">{introNote}</p>}

        </div>

      </div>

    </section>

  );

};



export default CaseStudyIntro;

